import React from 'react';
import PropTypes from 'prop-types';
import VisibilityIcon from '@material-ui/icons/Visibility';
import { IconButton } from '@material-ui/core';

const VisibilityButton = (props) => {
	// props
	const { onShow, color = 'primary', className } = props;

	return (
		<IconButton
			aria-label='add'
			onClick={onShow}
			color={color}
			className={className}
		>
			<VisibilityIcon />
		</IconButton>
	);
}

VisibilityButton.propTypes = {
	onShow: PropTypes.func,
	color: PropTypes.oneOf(['default', 'primary', 'secondary']),
	className: PropTypes.string
}
export default VisibilityButton;